import BaseApi from './baseApi';
import INoticeOfLossDetail from '../models/INoticeOfLossDetail';
import IAuthentication from '../models/IAuthentication';
import { values } from 'lodash';
export default class InboundsNoticeOfLossDetailApi extends BaseApi {
    idUser : string = "";
    constructor() {
        super("dataaccess", "NoticeOfLoss");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
    }

    async GetInboundsNoticeOfLossDetail(noticeOfLossId: string) : Promise<INoticeOfLossDetail[]> {
        let json : string = this.getJsonRead(noticeOfLossId);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var inboundsNoticeOfLossDetail: INoticeOfLossDetail[] = [];
            inboundsNoticeOfLossDetail = response.data as INoticeOfLossDetail[];
            return inboundsNoticeOfLossDetail;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveInboundsNoticeOfLossDetail(inboundsNoticeOfLossDetail: INoticeOfLossDetail) : Promise<string> {
        const json = this.getJsonSave(inboundsNoticeOfLossDetail);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateInboundsNoticeOfLossDetail(inboundsNoticeOfLossDetail: INoticeOfLossDetail) : Promise<boolean> {
        const json = this.getJsonUpdate(inboundsNoticeOfLossDetail);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteInboundsNoticeOfLossDetail(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "InboundsNoticeOfLossDetail",
            "conditions": [{
                "Item1": "InboundsNoticeOfLossDetail",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(inboundsNoticeOfLossDetail: INoticeOfLossDetail) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idNoticeOfLoss",
                "Item2": inboundsNoticeOfLossDetail.idNoticeOfLoss
            }, {
                "Item1": "idInboundDeliveryNoteDetail",
                "Item2": inboundsNoticeOfLossDetail.idDeliveryNoteDetail
            }, {
                "Item1": "idListPallet",
                "Item2": inboundsNoticeOfLossDetail.idListPallet
            }, {
                "Item1": "idPallet",
                "Item2": inboundsNoticeOfLossDetail.idPallet
            }, {
                "Item1": "casesPerPallet",
                "Item2": inboundsNoticeOfLossDetail.casesPerPallet
            }, {
                "Item1": "goodsPerCase",
                "Item2": inboundsNoticeOfLossDetail.goodsPerCase
            }, {
                "Item1": "totalGoods",
                "Item2": inboundsNoticeOfLossDetail.totalGoods
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "InboundsNoticeOfLossDetail"
        };
        return json;
    }

    private getJsonUpdate(inboundsNoticeOfLossDetail: INoticeOfLossDetail) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "idNoticeOfLoss",
                "Item2": inboundsNoticeOfLossDetail.idNoticeOfLoss
            }, {
                "Item1": "idInboundDeliveryNoteDetail",
                "Item2": inboundsNoticeOfLossDetail.idDeliveryNoteDetail
            }, {
                "Item1": "idListPallet",
                "Item2": inboundsNoticeOfLossDetail.idListPallet
            }, {
                "Item1": "idPallet",
                "Item2": inboundsNoticeOfLossDetail.idPallet
            }, {
                "Item1": "casesPerPallet",
                "Item2": inboundsNoticeOfLossDetail.casesPerPallet
            }, {
                "Item1": "goodsPerCase",
                "Item2": inboundsNoticeOfLossDetail.goodsPerCase
            }, {
                "Item1": "totalGoods",
                "Item2": inboundsNoticeOfLossDetail.totalGoods
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "InboundsNoticeOfLossDetail",
            "keyvalue": inboundsNoticeOfLossDetail.id
        };
        return json;
    }

    private getJsonRead(noticeOfLossId: string) : any {
        const json = {
            "fields": [{
                "Item1": "InboundsNoticeOfLossDetail",
                "Item2": "id"
            }, {
                "Item1": "InboundsNoticeOfLossDetail",
                "Item2": "idNoticeOfLoss"
            }, {
                "Item1": "InboundsNoticeOfLossDetail",
                "Item2": "idInboundDeliveryNoteDetail as idDeliveryNoteDetail"
            }, {
                "Item1": "InboundsNoticeOfLossDetail",
                "Item2": "idListPallet"
            }, {
                "Item1": "ListPalletTypes",
                "Item2": "name as listPalletName"
            }, {
                "Item1": "InboundsNoticeOfLossDetail",
                "Item2": "idPallet"
            }, {
                "Item1": "InboundsNoticeOfLossDetail",
                "Item2": "casesPerPallet"
            }, {
                "Item1": "InboundsNoticeOfLossDetail",
                "Item2": "goodsPerCase"
            }, {
                "Item1": "InboundsNoticeOfLossDetail",
                "Item2": "totalGoods"
            }],
            "tables": [{
                "Item1": "InboundsNoticeOfLossDetail"
            }, {
                "Item1": "ListPalletTypes"
            }],
            "joins": [{
                "Item1": "InboundsNoticeOfLossDetail",
                "Item2": "idListPallet",
                "Item3": "ListPalletTypes",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "InboundsNoticeOfLossDetail",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "InboundsNoticeOfLossDetail",
                "Item2": "idNoticeOfLoss",
                "Item3": "=",
                "Item4": noticeOfLossId
            }]
        };
        return json;
    }
}
